// @flow

import ObjectCollection from './ObjectCollection';
import ContentDeliveryNetwork from './ContentDeliveryNetwork';
import { outerHeight } from './Helpers';
import { App } from '../jsti/core';
import Environment from './Environment';
import Collection from './Collection';
import Url from './Url/Url';
import SessionManager from './SessionManager';

export default class {
  #environment: Environment;
  #app: App;
  #url: Url;
  #translations: ObjectCollection;
  #contentDeliveryNetwork: ContentDeliveryNetwork;
  activeViewPanels: Collection<string>;
  #sessionManager: SessionManager;

  /**
   * Create a new instance of a Store
   */
  constructor() {
    this.#environment = new Environment();
    this.#app = App.getInstance();
    this.#url = new Url();
    this.#translations = new ObjectCollection();
    this.#sessionManager = new SessionManager();
    this.activeViewPanels = new Collection();
  }

  /**
   * Get a specific public translation by the given key.
   */
  getTranslation(key: string): string {
    return this.#translations.get(key) || '';
  }

  /**
   * Calculate the height of the header.
   */
  get headerHeight(): number {
    const header = document.querySelector('header.header');
    if (!header) return 0;

    return outerHeight(header);
  }

  /**
   * Getter for the App instance
   *
   * @returns App
   */
  get app(): App {
    return this.#app;
  }

  /**
   * Getter for the translations
   *
   * @returns {ObjectCollection}
   */
  get translations(): ObjectCollection {
    return this.#translations;
  }

  /**
   * Get the environment
   *
   * @returns {Environment}
   */
  get environment(): Environment {
    return this.#environment;
  }

  /**
   * Getter for the session manager
   */
  get sessionManager(): SessionManager {
    return this.#sessionManager;
  }

  /**
   * Get the CDN of the Store
   */
  get cdn(): ContentDeliveryNetwork {
    return this.#contentDeliveryNetwork;
  }

  /**
   * Set the CDN of the Store
   */
  set cdn(cdnUrl: string): void {
    this.#contentDeliveryNetwork = new ContentDeliveryNetwork(cdnUrl);
  }

  /**
   * Retrieve a helper class which can manipulate the current url and do some other things
   */
  get url(): Url {
    return this.#url;
  }

  /**
   * Override the url instance
   * Used for pages which use different types of filtering etc.
   */
  set url(url: Url): void {
    this.#url = url;
  }
}
